module.exports = __webpack_public_path__ + "banner.b042cc0669f017889318.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/mohammed/Desktop/OldLaptop/www-data/www-data/htdocs/remoteApi-front/ng-app/src/assets/images/banner.jpg
// module id = ../../../../../src/assets/images/banner.jpg
// module chunks = styles